import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=e08407ea&scoped=true"
import script from "./additional-info.vue?vue&type=script&lang=js"
export * from "./additional-info.vue?vue&type=script&lang=js"
import style0 from "./additional-info.vue?vue&type=style&index=0&id=e08407ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08407ea",
  null
  
)

export default component.exports